
import { memo, useState, useEffect, useMemo, useCallback } from "react";
import { Dropdown, Form, Toast, Modal as ReactModal } from "react-bootstrap";
import { Modal, Select, Radio, Button } from "antd";
import styles from "./index.module.scss";
import { useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Loaders from "../../../../loader/loader";
import DatePicker from "react-datepicker";
import { useForm, Controller } from "react-hook-form";
import { CoreServices, SocialmediaServices, TicketServices, WhatsappService } from "../../../../../base/service/apiServices";
import { LocalStorage } from "../../../../../custom_hooks/localStorageKeys";
import { GetItemFromStorage } from "../../../../../custom_hooks/useStorage";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import presenceService from "../../../../../base/service/presence";
import callChatService from "../../../../../base/service/chatService";
import { ChatState } from "../../../../../base/models/model";
import { ChatActions } from "../../../../../store/slices/chat_slice/chat_slice";
import { useDispatcher } from "../../../../../custom_hooks/use_app_dispatch";
import store from "../../../../../store/redux-store/root_store";
import React from "react";
import calendericon from '../../../../../styles/images/calendericoagentn.svg'
import { aiGrouping } from "../../../../../base/utils";


const TicketingModal = React.memo(({ cancelTicketModal, speedoMeter, ticketData }: any) => {

    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
    const LoginUserDetails: any = userDetails;
    const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
    const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);

    let { currentSession }: any = chatReducer;
    let { autoAssignTicketing }: any = chatReducer
    const dispatch = useDispatcher();
    const [errorMsg, setErrorMsg] = useState<any>({ msg: "", status: "" });
    const [loading, setLoading] = useState<any>(false);
    const [priority, setPriority] = useState<any>([]);
    const [ticketType, setTicketType] = useState<any>([]);
    const [description, setDescription] = useState<any>("");
    const [assignee, setAssignee] = useState<any>([]);
    const [tagData, setTagData] = useState<any>([]);
    const [filterTagData, setFilterTagData] = useState<any>([]);
    const [customerContact, setCustomerContact] = useState<any>([]);
    const [groupData, setGroupData] = useState<any>([]);
    const [userData, setUserData] = useState<any>([]);
    const autoAssignData = useSelector((state: any) => state.autoAssignTicketing);

    const [assigneeRadio, setAssigneeRadio] = useState<any>({ autoAssignee: true, selectAssignee: false, });
    const [statusData, setStatusData] = useState<any>([]);
    const [layout, setLayout] = useState<any>([]);
    const [orgLayout, setOrgLayout] = useState<any>([]);
    const [layoutData, setLayoutData] = useState<any>([{ TicketLayoutId: 0, LayoutName: "Default Layout" },]);

    const [selectLayout, setSelectLayout] = useState<any>(layoutData[0]);

    const get_from_contact = localStorage.getItem("from_contact");
    const get_Dtails: any = localStorage.getItem("row_Value");
    const get_stringyfy = JSON.parse(get_Dtails);
    const [contactName, setContactName] = useState<any>("");

    const { agentStatus } = store.getState().agentState;
    const { users } = store.getState().userList;
    const [statusList, setStatusList] = useState<any>();
    const [isModalVisible, setIsModalVisible] = useState<any>(true);
    const [selectedAssigneeId, setSelectedAssigneeId] = useState<any>(null);

    let productId = GetItemFromStorage(LocalStorage.PRODUCT_ID)
    const {
        handleSubmit: handleParentSubmit,
        register: registerParent,
        formState: { errors: parentErrors },
        reset: resetParent,
        control,
        setValue,
        trigger,
        clearErrors,
        getValues,
        watch,
    } = useForm();
    useEffect(() => {
        resetParent({
            ticket_type: "",
            customer_contact: "",
            tag: "",
            group: "",
            assignee: "",
            priority_select: "",
            ticket_source: "",
        });
        getDefaultStatusDataFun();
        getPriorityDataFun();
        getTagDataFun();
        getTicketTypeFun();
        getContactDataFun();
        getGroupDataFun();
        getUserDataFun();
        getLayoutDataFun();
        getStatusList();
    }, []);

    const handleChange = (content: any) => {
        setValue("ticket_description", content?.replace(/<\/?p>|<br>/g, ""), { shouldValidate: true });
        if (content?.replace(/<p>|<\/p>|<br>/g, "")) {
            trigger("ticket_description");
        }
        setDescription(content)
    };

    const getDefaultStatusDataFun = () => {
        try {
            const body = {
                "p_CompanyId": LoginUserDetails.companyId,
                "p_ProductId": productId,
                "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
            }
            TicketServices.post(body, `/get_ticket_default_status_list`).then(async (response: any) => {
                if (response.data.statusCode !== undefined && response.data.statusCode == 0) {
                    setStatusData(response.result);
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getPriorityDataFun = async () => {
        try {
            const body = {
                "p_TypeGroupID": "1116",
            }
            await TicketServices.post(body, `/get_type_code`).then((response: any) => {
                if (response.data.statusCode !== undefined && response.data.statusCode == 0) {
                    setPriority(response.data.result[0]);
                    resetParent({
                        priority_select: "",
                    });
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getTagDataFun = async () => {
        try {
            const body = {
                "p_TicketTagId": 0,
                "p_CompanyId": userDetails.company_id,
                "p_ProductId": productId,
                "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
            }
            await TicketServices.post(body, `/get_ticket_tag`).then((response: any) => {
                if (response.data.statusCode !== undefined && response.data.statusCode == 0) {
                    let tag_data: any = [];
                    for (let data of response.data.result[0]) {
                        if (data.IsActive === 1) {
                            let json_data = { value: data.TicketTagId, label: data.TagName };
                            tag_data.push(json_data);
                        }
                    }
                    setTagData(tag_data);
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getTicketTypeFun = async () => {
        try {
            const body = {
                "p_TicketTypeId": 0,
                "p_CompanyId": userDetails.company_id,
                "p_ProductId": productId,
                "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
            }

            await TicketServices.post(body, `/get_ticket_type`).then((response: any) => {
                if (response.data.statusCode !== undefined && response.data.statusCode == 0) {
                    let ticket_type_data: any = [];
                    for (let data of response.data.result) {

                        if (data.IsActive === 1) {

                            let json_data = {
                                TicketTypeId: data.TicketTypeId,
                                TicketTypeName: data.TicketTypeName,
                            };
                            ticket_type_data.push(json_data);
                        }
                    }
                    setTicketType(ticket_type_data);
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getContactDataFun = async () => {
        try {
            await CoreServices.get(`/get_customer_conatct/null`).then((response: any) => {
                if (response.data.statusCode !== undefined && response.data.statusCode == 200) {
                    let updatedData = response.data.getConatctListRes.filter((customer: any) => customer.firstName && customer.email)
                    setCustomerContact(updatedData);
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getGroupDataFun = async () => {
        try {
            const body = {
                "p_CompanyId": userDetails.company_id,
                "p_ProductId": productId,
                "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
            }
            await TicketServices.post(body, `/get_group_list`).then((response: any) => {
                if (response.data.statusCode !== undefined && response.data.statusCode == 0) {
                    const data: any = [];
                    data.push(...response.data.result[0]);
                    setGroupData(data);
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getUserDataFun = async () => {
        try {
            const body = {
                "p_CompanyId": userDetails.company_id,
                "p_ProductId": productId,
                "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
            }
            await TicketServices.post(body, `/get_user_group_list`).then((response: any) => {
                if (response.data.statusCode !== undefined && response.data.statusCode == 0) {
                    setUserData(response.data.result[0]);
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getLayoutDataFun = async () => {
        try {
            const body = {
                "p_CompanyId": userDetails.company_id,
                "p_ProductId": productId,
                "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
            }
            await TicketServices.post(body, `/get_layout`).then((response: any) => {

                if (response.data.statusCode !== undefined && response.data.statusCode == 0) {

                    setLayoutData([...layoutData, ...response.data.result[0]]);
                }
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
        } catch (error) {
            console.log(error);
        }
    };

    const getLayoutDetailsFun = async (layoutId: any) => {
        const body = {
            "p_CompanyId": LoginUserDetails.companyId,
            "p_ProductId": productId,
            "p_LoggedInUserID": LoginCcaasUserDetails?.UserID,
            "p_TicketLayoutId": layoutId
        }

        try {
            const response = await TicketServices.post(body, '/get_ticket_label');

            if (response.data.statusCode !== undefined && response.data.statusCode === 0) {
                const data: any = response.data.result ? response.data.result[0] : [];

                // const filter_data: any = Array.from(new Set(data.map((row: any) => row.TicketFieldId)));
                const uniqueFieldIds = Array.from(new Set(data.map((row: any) => row.TicketFieldId)));
                const layoutData = uniqueFieldIds
                    .map((fieldId: any) => data.find((row: any) => row.TicketFieldId.toString() === fieldId.toString()))
                    .filter((row) => row !== undefined);

                setOrgLayout(data);
                setLayout(layoutData);
                if (!data || data.length === 0) {
                    console.log("No layout data received");
                    setOrgLayout([]);
                    setLayout([]);
                    return;
                }
            }
        } catch (error) {
            console.error('Error fetching layout details:', error);
        }
    };

    const getStatusList = () => {
        const body = {
            "p_CompanyId": LoginUserDetails.companyId,
            "p_ProductId": productId,
            "p_LoggedInUserID": LoginCcaasUserDetails?.UserID
        }
        TicketServices.post(body, `/get_ticket_default_status_list`).then((response) => {
            if (response.data.statusCode === 0) {
                setStatusList(response.data.result);
            }
        })
    }

    const onChangeGroupFun = (eve: any) => {
        try {
            resetParent({
                assignee: "",
            });
            if (parseInt(eve) === 0) {
                setAssignee([]);
                return;
            }
            const group_data = [...userData];
            const filter_user = group_data.filter(
                (row) => row.TicketGroupId.toString() === eve.toString()
            );
            setAssignee(filter_user);
        } catch (error) {
            console.log(error);
        }
    };

    // const getTicketDomain = () =>{
    //     const body = {
    //         "p_CompanyId": LoginUserDetails.companyId
    //     }
    // }
    const createTicket = () => {
        handleParentSubmit(handleFormSubmit)();
    };

    const handleFormSubmit = (data: any) => {
        createTicketFun(data);
    };

    const getMultiChoiceDataFun = (fieldTypeId: any) => {
        const data: any = [];
        for (let drop_down of orgLayout) {
            if (fieldTypeId.toString() === drop_down.FieldTypeId.toString()) {
                data.push({
                    TicketFieldId: drop_down.TicketFieldId,
                    FieldLabel: drop_down.FieldLabel,
                });
            }
        }
        return data;
    };

    // const selectLayoutFun = (row: any, index: any) => {
    //     setSelectLayout(row);
    //     if (index !== 0) {
    //         getLayoutDetailsFun(row.TicketLayoutId);
    //     } else {
    //         setLayout([]);
    //         setOrgLayout([]);
    //     }
    // };

    const selectLayoutFun = (value: any, row: any) => {
        const data = row?.data
        setSelectLayout(data);
        if (data.TicketLayoutId !== 0) {
            console.log("data data TicketLayoutId=>>>>>", data.TicketLayoutId)
            getLayoutDetailsFun(data.TicketLayoutId);
        } else {
            setLayout([]);
            setOrgLayout([]);
        }
    };

    const createTicketFun = async (data: any) => {
        if (description === '') {
            return;
        }
        setIsModalVisible(false);
        cancelTicketModal();
        try {
            console.log("dtafafa", data)
            const statusId = statusList?.filter((elem: any) => elem.StatusName === "Open");
            const tag_data = filterTagData.map((row: any) => row.value);
            setLoading(true);
            const layout_value = await getFormLayoutDataFun(data);
            const body = {
                p_TicketSubject: data.ticket_subject,
                p_TicketDescription: description,
                p_TicketPriority: data.priority_select,
                p_TicketSourceId: productId,
                p_TicketTypeId: data.ticket_type === "" ? 0 : data.ticket_type,
                p_TicketRequestorId: LoginCcaasUserDetails?.UserID,
                p_TicketAssignee: assigneeRadio.autoAssignee ? 1 : 2,
                p_TicketAssignedToGroupId: assigneeRadio.autoAssignee
                    ? autoAssignTicketing?.TicketGroupId
                    : 0,
                p_TicketAssignedToAgentId: assigneeRadio.autoAssignee
                    ? null
                    : data.assignee === ""
                        ? 0
                        : data.assignee,
                p_TicketTagId: filterTagData?.length > 0 ? filterTagData.join(",") : "",
                p_TicketAssociateCustContact:
                    data.customer_contact && data.customer_contact !== ""
                        ? data.customer_contact
                        : 0,

                p_TicketLayout: selectLayout.TicketLayoutId,
                p_TicketLayoutValue: JSON.stringify(layout_value),
                p_TicketLayoutStatus: 0,
                p_TicketStatusID: statusId?.[0]?.StatusId,
                p_TicketMode: 1,
                p_RequesterName: `${userDetails?.first_name} ${userDetails?.last_name}`,
                p_CompanyName: userDetails?.companyName,
                p_ClonedFromTicketId: null,
                p_CompanyId: userDetails.company_id ?? null,
                p_ProductId: productId,
                p_HistoryId: ticketData?.historyId ?? null,
                p_ChannelTypeId:
                    ticketData?.channelType === 'Call' ? 2003001 :
                        ticketData?.channelType === 'Chat' ? 2003002 :
                            ticketData?.channelType === 'Email' ? 2003003 :
                                ticketData?.channelType === 'SMS' ? 2003004 :
                                    ticketData?.channelType === 'Whatsapp' ? 2003005 :
                                        ticketData?.channelType === 'Facebook' ? 2003006 :
                                            ticketData?.channelType === 'Instagram' ? 2003007 :
                                                ticketData?.channelType === 'Videomeet' ? 2003008 : null,
            };

            await TicketServices.post(body, `/insert_update_ticket_creation`).then((response: any) => {
                let { incomingCallDetail } = popUpDetails;
                let status: any = null
                const presence = sessionStorage.getItem('presence')
                if (agentStatus?.length > 0) {
                    [status] = agentStatus.filter((i: any) => { return presence === i?.statusName?.trim() })
                }
                let enableStatus: any = null
                if (users.length > 0) {
                    [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
                }
                presenceService?.io?.emit("updatestate_backend", {
                    domainId: LoginUserDetails?.domainId,
                    isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
                    isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
                    isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
                    isChatTransfer: status?.isChatTransfer ?? 0,
                    isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
                    isEmailTransfer: status?.isEmailTransfer ?? 0,
                    stateTime: Math.floor(Date.now() / 1000),
                    statusName: presence,
                    ext: LoginUserDetails?.ext,
                    email: LoginUserDetails?.Email,
                    userId: LoginUserDetails?.UserID,
                    routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
                    userName: LoginCcaasUserDetails?.UserName,
                    roleId: LoginCcaasUserDetails?.roleid,
                    agentStatus: Object.keys(incomingCallDetail)?.length > 0 ? 0 : 1,
                    skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
                    routingMethod: enableStatus?.routingMethod ?? 0
                });
                let data = {
                    ext: LoginUserDetails?.ext,
                    domainId: LoginUserDetails?.domainId
                };
                callChatService.io.emit("agent_ready_for_queue_users", data);
                WhatsappService.post(data, `/send_agent_status_queue`);
                SocialmediaServices.post(data, `/send_agent_status_queue_facebook`);
                SocialmediaServices.post(data, `/send_agent_status_queue_instagram`);
                if (response.statusCode !== undefined && response.statusCode == 0) {

                    aiGrouping({ p_CompanyId: LoginUserDetails.companyId });
                    setIsModalVisible(false);

                    cancelTicketModal();
                    const body = {
                        ticketId: response.data.result[0][0].TicketId,
                        historyId: currentSession.channelType === 'Whatsapp' ? currentSession.WhatsappHistoryId : currentSession.channelType === 'Sms' ? currentSession.SMSHistoryId : currentSession.channelType === 'Email' ? currentSession.EmailHistoryId :
                            currentSession.channelType === 'Instagram' ? currentSession?.InstagramHistoryId :
                                currentSession?.CallHistoryId ? currentSession?.CallHistoryId : currentSession?.ChatHistoryId,
                        channelType: currentSession.channelType === 'Whatsapp' ? "Whatsapp" : currentSession.channelType === 'Sms' ? "Sms" : currentSession.channelType === 'Email' ? "Email" : currentSession?.CallHistoryId ? 'Call' : currentSession.channelType === 'Instagram' ? 'Instagram' : 'Chat'
                    }
                    CoreServices.put(body, `/update_ticketing_id`).then((response: any) => {
                        notification.info({
                            message: `Ticket created successfully`,
                            placement: "topRight",
                            className: "toastNotification success",
                            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
                            </svg>,
                            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
                            </svg>,
                            duration: 3,
                            top: 70,
                        });
                    })
                }
                if (response.data.result[0][0].errcode == 0) {
                    setIsModalVisible(false);
                    cancelTicketModal();
                    const body = {
                        ticketId: response.data.result[0][0].TicketId,
                        historyId: currentSession.channelType === 'Whatsapp' ? currentSession.WhatsappHistoryId : currentSession.channelType === 'Sms' ? currentSession.SMSHistoryId : currentSession.channelType === 'Email' ? currentSession.EmailHistoryId :
                            currentSession.channelType === 'Instagram' ? currentSession?.InstagramHistoryId :
                                currentSession?.CallHistoryId ? currentSession?.CallHistoryId : currentSession?.ChatHistoryId,
                        channelType: currentSession.channelType === 'Whatsapp' ? "Whatsapp" : currentSession.channelType === 'Sms' ? "Sms" : currentSession.channelType === 'Email' ? "Email" : currentSession?.CallHistoryId ? 'Call' : currentSession.channelType === 'Instagram' ? 'Instagram' : 'Chat'
                    }


                    // dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
                    CoreServices.put(body, `/update_ticketing_id`).then((response: any) => {
                        notification.info({
                            message: `Ticket created successfully`,
                            placement: "topRight",
                            className: "toastNotification success",
                            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
                            </svg>,
                            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
                            </svg>,
                            duration: 3,
                            top: 70,
                        });
                    })
                }
            }).catch((error) => {
                dispatch(ChatActions.sessionRemoveAfterEnd(currentSession?.sessionId));
            }).catch((error: any) => {
                notification.error({
                    message: 'Internal Server Error',
                    placement: "topRight",
                    duration: 7,
                    top: 70,
                });
            })
                .finally(() => {
                    speedoMeter();
                    dispatch(ChatActions.setAutoAssignTicket({}))
                })
        } catch (error) {
            console.log(error);
        }
    };

    const getFormLayoutDataFun = (layout_data: any) => {
        try {
            return new Promise(async (resolve) => {
                const data: any = [];
                for (let _layoutdata of layout) {
                    data.push({
                        TicketFieldid: _layoutdata.TicketFieldId,
                        Ticketfieldvalue:
                            layout_data[_layoutdata.APIName] !== undefined
                                ? layout_data[_layoutdata.APIName]
                                : _layoutdata.APIName,
                    });
                }
                resolve(data);
            });
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        let ticketContact = localStorage.getItem("from_contact");
        if (ticketContact != "" && ticketContact == "contact_to_create_ticket") {
            setContactName(get_stringyfy?.firstName + " " + get_stringyfy?.lastName)
        }
    }, [])

    // useEffect(() => {
    //     if (!autoAssignTicketing) return;
    //     if (!priority.length || !ticketType.length) return;
    //     setDescription(autoAssignTicketing.description || "");
    //     setValue("ticket_description", autoAssignTicketing?.description || "", { shouldValidate: true });
    //     setValue("ticket_subject", autoAssignTicketing?.subject || "", { shouldValidate: true });
    //     setValue("ticket_requester", `${userDetails?.first_name} ${userDetails?.last_name}`);
    //     const matchedPriority = priority.find((p: { TypeCodeName: string }) =>
    //         p.TypeCodeName === autoAssignTicketing.priority
    //     );

    //     const matchedType = ticketType.find((p: { TicketTypeName: string }) =>
    //         p.TicketTypeName === autoAssignTicketing.ticket_type
    //     );

    //     if (matchedPriority) {
    //         setValue("priority_select", matchedPriority.TypeCodeID, { shouldValidate: true });
    //     }

    //     if (matchedType) {
    //         setValue("ticket_type", matchedType.TicketTypeId, { shouldValidate: true });
    //     }

    //     setLoading(false);
    // }, [autoAssignTicketing, priority, ticketType, setValue, setDescription, setLoading]);

    const [selectedPriority, setSelectedPriority] = useState<string | undefined>(undefined);


    useEffect(() => {
        if (!autoAssignTicketing) return;
        if (!priority.length || !ticketType.length) return;

        setDescription(autoAssignTicketing.description || "");
        setValue("ticket_description", autoAssignTicketing?.description || "", { shouldValidate: true });
        setValue("ticket_subject", autoAssignTicketing?.subject || "", { shouldValidate: true });
        setValue("ticket_requester", `${userDetails?.first_name} ${userDetails?.last_name}`);

        if (customerContact && customerContact.length) {
            const matchedContact = customerContact.find(
                (row: any) => row.coid === currentSession?.calledPersonDetails?.coid
            );
            if (matchedContact) {
                setValue("customer_contact", matchedContact.coid);
            }
        }

        const matchedPriority = priority.find((p: any) => p.TypeCodeName === autoAssignTicketing.priority);
        const matchedType = ticketType.find((p: any) => p.TicketTypeName === autoAssignTicketing.ticket_type);

        if (matchedPriority) {
            setValue("priority_select", matchedPriority.TypeCodeID, { shouldValidate: true });
            setSelectedPriority(matchedPriority.TypeCodeID);
        }

        if (matchedType) {
            setValue("ticket_type", matchedType.TicketTypeId, { shouldValidate: true });
        }
        clearErrors('ticket_subject')
        clearErrors('ticket_description')
        clearErrors('priority_select')

        setLoading(false);
    }, [autoAssignTicketing, priority, ticketType]);

    const { Option } = Select;


    return (
        <>
            <Modal
                open={isModalVisible}
                title={<>
                    <div className={styles.createticheader}>
                        <h5 className={styles.headertxt}>Create ticket</h5>
                        <div className={styles.rightheader}>
                            <Select
                                className="antSelect ticketnewheaderselect"
                                placeholder="Choose Layout"
                                suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                    <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                </svg>}
                                value={selectLayout?.LayoutName}
                                onChange={(e, l) => selectLayoutFun(e, l)}
                            >
                                {layoutData.map((row: any, index: any) => {

                                    return (
                                        <Select.Option key={row.TicketLayoutId} data={row} value={row.TicketLayoutId}>
                                            {row.LayoutName}
                                        </Select.Option>
                                        // <option
                                        //     key={row.TypeCodeID}
                                        //     // onClick={() => selectLayoutFun(row, index)}
                                        // >
                                        //     {row.LayoutName}
                                        // </option>
                                    );
                                })}
                            </Select>
                            {/* <Dropdown>
                            <Dropdown.Toggle variant="success" id="dropdown-basic">
                                <p>
                                    {selectLayout.LayoutName}
                                    <svg
                                        width="12"
                                        height="6"
                                        viewBox="0 0 12 6"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z"
                                            fill="#757676"
                                        />
                                    </svg>
                                </p>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="titledrops">
                                {layoutData.map((row: any, index: any) => {
                                    return (
                                        <Dropdown.Item
                                            key={row.TypeCodeID}
                                            onClick={() => selectLayoutFun(row, index)}
                                        >
                                            {row.LayoutName}
                                        </Dropdown.Item>
                                    );
                                })}
                            </Dropdown.Menu>
                        </Dropdown> */}
                        </div>
                    </div>
                </>}
                className="customModal ticketnewmodal"
                centered
                closeIcon={<span className="icon__Close16" onClick={() => {
                    setIsModalVisible(false);
                    cancelTicketModal();
                    dispatch(ChatActions.setAutoAssignTicket({}))
                }}></span>}
                footer={[
                    <div className={styles.createticmodalfooter}>
                        <Button onClick={() => {
                            setIsModalVisible(false);
                            cancelTicketModal();
                        }} className="buttonCancel">
                            Cancel
                        </Button>
                        <Button type="primary" className="buttonSave" onClick={createTicket}>
                            Create
                        </Button>
                    </div>
                ]}
            >
                <div className={styles.createticketmodal}>
                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label>
                            {" "}
                            Ticket subject <span>*</span>
                        </label>
                        <div className={styles.rightfield}>
                            <input
                                className={styles.textinp}
                                placeholder="Please enter ticket subject"
                                type="text"
                                {...registerParent("ticket_subject", {
                                    required: "Subject is required",
                                })}
                                defaultValue={autoAssignTicketing?.subject}
                            />
                            {parentErrors?.ticket_subject?.message && (
                                <p className={styles.errortxt}>
                                    {parentErrors?.ticket_subject?.message?.toString()}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label>
                            {" "}
                            Description <span>*</span>
                        </label>
                        <div className={styles.rightfield}>
                            {/* <textarea placeholder='Enter description' maxLength={500} {...registerParent("ticket_description", { required: "Description is required" })} /> */}

                            <div className={`quilleditorticketnew`}>
                                <ReactQuill
                                    theme="snow"
                                    placeholder="Enter description"
                                    modules={{
                                        toolbar: [
                                            [
                                                "bold",
                                                "italic",
                                                "underline",
                                                "strike",
                                                "blockquote",
                                            ],
                                            ["link", "image", "video"],
                                            [{ list: "ordered" }, { list: "bullet" }],
                                        ],
                                        clipboard: {
                                            matchVisual: false,
                                        },
                                    }}
                                    formats={[
                                        "header",
                                        "font",
                                        "size",
                                        "color",
                                        "bold",
                                        "italic",
                                        "underline",
                                        "strike",
                                        "blockquote",
                                        "list",
                                        "bullet",
                                        "indent",
                                        "link",
                                        "image",
                                        "video",
                                        "align",
                                    ]}
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        // minHeight: '300px',
                                    }}
                                    value={description}
                                    onChange={(content) => handleChange(content)}
                                //onChange={(e: any) => handleChange(e)}
                                />
                                <input {...registerParent("ticket_description",
                                    { required: "Description is required" })} style={{ display: "none" }} />
                            </div>
                            {parentErrors?.ticket_description?.message && (
                                <p className={styles.errortxt}>
                                    {parentErrors?.ticket_description?.message?.toString()}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label>
                            Priority <span>*</span>
                        </label>
                        <div className={styles.rightfield}>
                            {/* <select
                                    {...registerParent("priority_select", {
                                        required: "Priority is required",
                                    })}
                                    defaultValue=""
                                >
                                    {" "}
                                    <option value="" disabled>
                                        Select Priority
                                    </option>
                                    {priority.map((row: any, index: any) => (
                                        <option key={index} value={row.TypeCodeID}>
                                            {row.TypeCodeName}
                                        </option>
                                    ))}
                                </select> */}
                            <Select
                                className="antSelect createticselect"
                                placeholder="Select Priority"
                                suffixIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                        {/* SVG content */}
                                    </svg>
                                }
                                {...registerParent("priority_select", {
                                    required: "Priority is required",
                                })}
                                value={selectedPriority}
                                onChange={(value) => {
                                    setSelectedPriority(value);
                                    setValue("priority_select", value, { shouldValidate: true });
                                    if (value) {
                                        clearErrors("priority_select");
                                    }
                                }}
                                options={priority.map((row: any) => ({
                                    value: row.TypeCodeID,
                                    label: row.TypeCodeName,
                                }))}
                            />

                            {parentErrors?.priority_select?.message && (
                                <p className={styles.errortxt}>
                                    {parentErrors?.priority_select?.message?.toString()}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label> Ticket source</label>
                        <div className={styles.rightfield}>
                            {/* <select {...registerParent("ticket_source")}>
                                    <option value="" disabled>
                                        Select Source
                                    </option> */}
                            {/* <option value={product.prod_name}>{product.prod_name}</option> */}
                            {/* <option value='Contact centre platform'>Contact centre platform</option> */}
                            {/* </select> */}
                            <Select
                                className="antSelect createticselect"
                                placeholder="Select ticket source"
                                suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                    <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                </svg>}
                                value="Contact centre platform" // Pre-selected value
                                disabled // Disables selection
                                options={[{ value: 'Contact centre platform', label: 'Contact centre platform' }]}

                            />
                        </div>
                    </div>

                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label>Ticket type</label>
                        <div className={styles.rightfield}>
                            {/* <select {...registerParent("ticket_type")}>
                                    <option value="" disabled>
                                        Select Ticket Type
                                    </option>
                                    {ticketType.map((x: any) => {
                                        return (
                                            <option value={x.TicketTypeId}>{x.TicketTypeName}</option>
                                        );
                                    })}
                                </select> */}
                            <Select
                                className="antSelect createticselect"
                                placeholder="Select ticket type"
                                value={ticketType?.find((row: { TicketTypeName: any; }) => row.TicketTypeName === autoAssignTicketing?.ticket_type)?.TicketTypeId || undefined}
                                suffixIcon={
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                        <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                    </svg>
                                }
                                {...registerParent("priority_select", {
                                    required: "Ticket Type is required",
                                })}
                                onChange={(value) => {
                                    setValue("ticket_type", value);
                                    if (value) {
                                        clearErrors("ticket_type");
                                    }
                                }}
                                options={ticketType?.map((row: any) => ({
                                    value: row.TicketTypeId,
                                    label: row.TicketTypeName,
                                }))}
                            />

                        </div>
                    </div>

                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label> Created by</label>
                        <div className={styles.rightfield}>
                            <input
                                className={styles.textinp}
                                readOnly
                                defaultValue={`${userDetails?.first_name} ${userDetails?.last_name}`}
                                {...registerParent("ticket_requester")}
                            />
                        </div>
                    </div>

                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label>Assignee</label>
                        <div className={styles.rightfield}>
                            <ul className={styles.radioelems}>
                                <li>
                                    <input
                                        type="radio"
                                        name="assignee"
                                        value="Auto assign"
                                        checked={assigneeRadio.autoAssignee}
                                        onClick={() =>
                                            setAssigneeRadio({
                                                autoAssignee: true,
                                                selectAssignee: false,
                                            })
                                        }
                                    />
                                    Auto assign
                                </li>
                                <li>
                                    <input
                                        type="radio"
                                        name="assignee"
                                        value="Assignee"
                                        checked={assigneeRadio.selectAssignee}
                                        onClick={() =>
                                            setAssigneeRadio({
                                                autoAssignee: false,
                                                selectAssignee: true,
                                            })
                                        }
                                    />
                                    Assignee
                                </li>
                            </ul>
                        </div>
                    </div>

                    {assigneeRadio.selectAssignee && (
                        <>
                            <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                                <label></label>
                                <div className={styles.rightfield}>
                                    {/* <span> Select Group</span>
                                        <select
                                            {...registerParent("group")}
                                            onChange={onChangeGroupFun}
                                            defaultValue=""
                                        >
                                            <option disabled value="">Select group name</option>
                                            {groupData.map((row: any, index: any) => {
                                                return (
                                                    <option key={index} value={row.TicketGroupId}>
                                                        {row.GroupName}
                                                    </option>
                                                );
                                            })}
                                        </select> */}
                                    <Select
                                        className="antSelect createticselect"
                                        placeholder="Select Group"
                                        suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                            <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                        </svg>}
                                        {...registerParent("group")}
                                        onChange={(value) => onChangeGroupFun(value)}
                                        options={groupData?.map((row: any) => ({
                                            value: row.TicketGroupId,
                                            label: row.GroupName,
                                        }))}
                                    />


                                </div>
                            </div>
                            <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                                <label></label>
                                <div className={styles.rightfield}>
                                    {/* <span >Select Assignee</span>
                                        <select {...registerParent("assignee")} defaultValue="">
                                            <option disabled value="">Select assignee name</option>
                                            {assignee.map((row: any, index: any) => {
                                                return (
                                                    <option key={index} value={row.UserId}>
                                                        {row.UserName}
                                                    </option>
                                                );
                                            })}
                                        </select> */}
                                    <Select
                                        className="antSelect createticselect"
                                        placeholder="Select Assignee"
                                        {...registerParent("assignee")}
                                        suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                            <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                        </svg>}
                                        options={assignee?.map((row: any) => ({
                                            value: row.UserId,
                                            label: row.UserName,
                                        }))}
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                        <label>Tag</label>
                        <div className={styles.rightfield}>
                            <Select
                                options={tagData}
                                value={filterTagData}
                                onChange={(e: any) => setFilterTagData(e)}
                                mode="multiple"
                                className="antSelect createticselect"
                                placeholder="Select Tag"
                                suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                    <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                </svg>}
                            />
                        </div>
                    </div>
                    {get_from_contact == "contact_to_create_ticket" ? (
                        <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                            <label>Requester</label>
                            <div className={styles.rightfield}>
                                <input
                                    value={contactName}
                                    {...registerParent("customer_contact")}
                                    readOnly
                                />
                            </div>
                        </div>
                    ) : (
                        // <div className={styles.fieldareanew}>
                        //     <label>Associate Customer Contact</label>
                        //     <div className={styles.rightfield}>
                        //         <Select
                        //             className="antSelect createticselect"
                        //             placeholder="Select ticket type"
                        //             suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                        //                 <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                        //             </svg>}
                        //             {...registerParent("customer_contact")} 
                        //             onChange={(value) => {
                        //                 const selectedRow = customerContact?.find((row: any) => row.coid === value);
                        //                 console.log("Selected Value:", value);
                        //                 console.log("Selected Row:", selectedRow);
                        //             }}
                        //             options={customerContact?.map((row: any) => ({
                        //                 value: row.coid,
                        //                 label: row.firstName,
                        //             }))}
                        //         >
                        //         </Select>
                        //     </div>
                        //     {/* <select {...registerParent("customer_contact")}>
                        //             <option value="" disabled >Select Customer Contact name</option>
                        //             {customerContact.map((x: any) => {
                        //                 return <option value={x.coid}>{x.firstName}</option>;
                        //             })}
                        //         </select> */}
                        // </div>
                        <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                            <label>
                                Requester <span>*</span>
                            </label>
                            <div className={styles.rightfield}>
                                <Controller
                                    control={control}
                                    name="customer_contact"
                                    rules={{ required: "Associate Customer Contact is required" }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <Select
                                                {...field}
                                                showSearch
                                                placeholder="Select Associate Customer Contact"
                                                className="antSelect createticselect"
                                                suffixIcon={
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                        <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                                    </svg>
                                                }
                                                filterOption={(input: string, option: any) => {
                                                    const label = option?.children?.toLowerCase?.() || "";
                                                    const email = option?.email?.toLowerCase?.() || "";
                                                    const phone = option?.phoneNumber?.toLowerCase?.() || "";
                                                    const coid = `${option?.value}`?.toLowerCase?.() || "";

                                                    const searchText = input.toLowerCase();

                                                    return (
                                                        label.includes(searchText) ||
                                                        email.includes(searchText) ||
                                                        phone.includes(searchText) ||
                                                        coid.includes(searchText)
                                                    );
                                                }}

                                                onChange={(value) => {
                                                    field.onChange(value);
                                                }}
                                            >
                                                {customerContact?.map((row: any) => (
                                                    <Option
                                                        key={row.coid}
                                                        value={row.coid}
                                                        email={row.email}
                                                        phoneNumber={row.phoneNumber}
                                                    >
                                                        {`${row.firstName} ${row.lastName || ""}`.trim()}
                                                    </Option>
                                                ))}
                                            </Select>
                                            {fieldState.error?.message && (
                                                <p className={styles.errortxt}>
                                                    {fieldState.error.message}
                                                </p>
                                            )}
                                        </>
                                    )}
                                />
                            </div>
                        </div>

                    )}

                    {layout.map((config: any) => {
                        return (
                            <>
                                <div className={`${styles.fieldareanew} ${styles.fieldareanewwidth}`}>
                                    <label>
                                        {" "}
                                        {config.FieldName === undefined
                                            ? "test"
                                            : config.FieldName}
                                        <span>{config.IsRequired ? "*" : ""}</span>
                                    </label>
                                    <div className={styles.rightfield}>
                                        {/* Text Box */}
                                        {config.FieldTypeId?.toString() === "1110001" && (
                                            <input
                                                {...registerParent(config.APIName, {
                                                    required: {
                                                        value: config.IsRequired,
                                                        message: `${config.FieldName} is required`,
                                                    },
                                                })}
                                                type="text"
                                                className={styles.textinp}
                                                id={config.APIName}
                                                maxLength={config.MaximunLength}
                                            />
                                        )}
                                        {/* Text Area */}
                                        {config.FieldTypeId?.toString() === "1110002" && (
                                            <textarea
                                                {...registerParent(config.APIName, {
                                                    required: {
                                                        value: config.IsRequired,
                                                        message: `${config.FieldName} is required`,
                                                    },
                                                })}
                                                className={styles.textareainp}
                                                id={config.APIName}
                                                maxLength={config.MaximunLength}
                                            />
                                        )}
                                        {/* Dropdown */}
                                        {config.FieldTypeId?.toString() === "1110006" && (
                                            // <select
                                            //     {...registerParent(config.APIName, {
                                            //         required: {
                                            //             value: config.IsRequired,
                                            //             message: `${config.FieldName} is required`,
                                            //         },
                                            //     })}
                                            //     id={config.APIName}
                                            // >
                                            //     {getMultiChoiceDataFun("1110006").map(
                                            //         (row: any, index: any) => {
                                            //             return (
                                            //                 <option key={index} value={row.FieldLabel}>
                                            //                     {row.FieldLabel}
                                            //                 </option>
                                            //             );
                                            //         }
                                            //     )}
                                            // </select>

                                            <Select
                                                className="antSelect createticselect"
                                                placeholder="Select ticket type"
                                                suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                                                    <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                                                </svg>}
                                                options={[{ value: 'sample', label: 'sample' }]}
                                            />

                                        )}
                                        {/* Multi Check Box */}
                                        {config.FieldTypeId?.toString() === "1110003" &&
                                            getMultiChoiceDataFun("1110003").map(
                                                (row: any, index: any) => {
                                                    return (
                                                        <>
                                                            <div className={styles.checkboxview}>
                                                                <input
                                                                    type="checkbox"
                                                                    {...registerParent(config.APIName, {
                                                                        required: {
                                                                            value: config.IsRequired,
                                                                            message: `${config.FieldName} is required`,
                                                                        },
                                                                    })}
                                                                    id={config.APIName}
                                                                    value={row.FieldLabel}
                                                                />
                                                                <label>{row.FieldLabel}</label>
                                                            </div>
                                                        </>
                                                    );
                                                }
                                            )}

                                        {config.FieldTypeId?.toString() === "1110009" && (
                                            <>
                                                <Form.Group controlId="formFile">
                                                    <Form.Control
                                                        {...registerParent(config.APIName, {
                                                            required: {
                                                                value: config.IsRequired,
                                                                message: `${config.FieldName} is required`,
                                                            },
                                                        })}
                                                        type="file"
                                                        id={config.APIName}
                                                        className={styles.inputupload}
                                                    />
                                                </Form.Group>
                                            </>
                                        )}
                                        {/* Date */}
                                        {config.FieldTypeId?.toString() === "1110004" && (
                                            <Controller
                                                control={control}
                                                name={config.APIName}
                                                rules={{
                                                    required: {
                                                        value: config.IsRequired,
                                                        message: `${config.FieldName} is required`,
                                                    },
                                                }}
                                                render={({ field }: any) => (
                                                    <div className="createticdatepicker">
                                                        <DatePicker
                                                            dateFormat={
                                                                config.LabelTypeId?.toString() === "1114001"
                                                                    ? "yyyy/MM/dd"
                                                                    : config.LabelTypeId?.toString() === "1114003"
                                                                        ? "MM/dd/yyyy"
                                                                        : "dd/MM/yyyy"
                                                            }
                                                            selected={field.value}
                                                            onChange={(date: any) => field.onChange(date)}
                                                            onBlur={field.onBlur}
                                                            showIcon
                                                            icon={
                                                                <img src={calendericon} alt="calender" />
                                                            }
                                                        />
                                                    </div>

                                                )}
                                            />
                                        )}
                                        {/* Date Time*/}
                                        {config.FieldTypeId?.toString() === "1110005" && (
                                            <Controller
                                                control={control}
                                                name={config.APIName}
                                                rules={{
                                                    required: {
                                                        value: config.IsRequired,
                                                        message: `${config.FieldName} is required`,
                                                    },
                                                }}
                                                render={({ field }: any) => (
                                                    <div className="createticdatepicker">
                                                        <DatePicker
                                                            showTimeSelect
                                                            timeFormat="HH:mm"
                                                            timeIntervals={15}
                                                            timeCaption="Time"
                                                            dateFormat={
                                                                config.LabelTypeId?.toString() === "1115001"
                                                                    ? "yyyy/MM/dd HH:mm"
                                                                    : config.LabelTypeId?.toString() === "1115003"
                                                                        ? "MM/dd/yyyy HH:mm"
                                                                        : "dd/MM/yyyy HH:mm"
                                                            }
                                                            selected={field.value}
                                                            onChange={(date: any) =>
                                                                field.onChange(new Date(date))
                                                            }
                                                            onBlur={field.onBlur}
                                                            showIcon
                                                            icon={
                                                                <img src={calendericon} alt="calender" />
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                        {/* Radio */}
                                        {config.FieldTypeId?.toString() === "1110007" && (
                                            <ul className={styles.radioelems}>
                                                {getMultiChoiceDataFun("1110007").map(
                                                    (row: any, index: any) => {
                                                        return (
                                                            <li key={index}>
                                                                <input
                                                                    type="radio"
                                                                    defaultChecked={
                                                                        config.DefaultValue?.toString() ===
                                                                        row.FieldLabel?.toString()
                                                                    }
                                                                    {...registerParent(config.APIName, {
                                                                        required: {
                                                                            value: config.IsRequired,
                                                                            message: `${config.FieldName} is required`,
                                                                        },
                                                                    })}
                                                                    value={row.FieldLabel}
                                                                />
                                                                {row.FieldLabel}
                                                            </li>
                                                        );
                                                    }
                                                )}
                                            </ul>
                                        )}
                                        {/* Url */}
                                        {config.FieldTypeId?.toString() === "1110008" && (
                                            <input
                                                {...registerParent(config.APIName, {
                                                    required: {
                                                        value: config.IsRequired,
                                                        message: `${config.FieldName} is required`,
                                                    },
                                                })}
                                                type="text"
                                                className={styles.textinp}
                                                id={config.APIName}
                                            />
                                        )}
                                        {/* pattern: { value: /^[A-Za-z]+$/, message: 'Numeric & Special characters not allowed', } */}
                                        {/* Number */}
                                        {config.FieldTypeId?.toString() === "1110010" &&
                                            (config.LabelTypeId?.toString() === "1113001" ? (
                                                <input
                                                    {...registerParent(config.APIName, {
                                                        required: {
                                                            value: config.IsRequired,
                                                            message: `${config.FieldName} is required`,
                                                        },
                                                        pattern: {
                                                            value: /^[0-9]+$/,
                                                            message: "Integer characters only allowed",
                                                        },
                                                    })}
                                                    type="text"
                                                    className={styles.textinp}
                                                    id={config.APIName}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                            ) : (
                                                <input
                                                    {...registerParent(config.APIName, {
                                                        required: {
                                                            value: config.IsRequired,
                                                            message: `${config.FieldName} is required`,
                                                        },
                                                        pattern: {
                                                            value: /^[0-9.]+$/,
                                                            message: "Decimal characters only allowed",
                                                        },
                                                    })}
                                                    type="text"
                                                    className={styles.textinp}
                                                    id={config.APIName}
                                                    onKeyPress={(event) => {
                                                        if (
                                                            !/[0-9]/.test(event.key) ||
                                                            (event.key === "." && event.key.includes("."))
                                                        ) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                            ))}
                                        {parentErrors?.[config.APIName]?.message && (
                                            <p className={"fieldareaerror"}>
                                                {parentErrors?.[config.APIName]?.message?.toString()}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
            </Modal >
            {loading && <Loaders />
            }
        </>
    );
});

export default TicketingModal;